module.exports = __webpack_public_path__ + "static/media/game_grid_blue.b097dd98.png";